import nhk from '../../../images/logo/media/nhk.png';
import j_wave from '../../../images/logo/media/j_wave.png';
import shibuya_no_radio from '../../../images/logo/media/shibuya_no_radio.jpg';
import sotokoto from '../../../images/logo/media/sotokoto.png';
import chiba_tv from '../../../images/logo/media/chiba_tv.png';
import tbs_radio from '../../../images/logo/media/tbs_radio.png';
import tv_asahi from '../../../images/logo/media/tv_asahi.png';
import toyokeizai from '../../../images/logo/media/toyokeizai.jpg';
import nikkin from '../../../images/logo/media/nikkin.jpg';
import nikkei from '../../../images/logo/media/nikkei.png';
import japan_agri_news from '../../../images/logo/media/japan_agri_news.jpg';
import nihon_tv from '../../../images/logo/media/nihontv.png';
import bs11 from '../../../images/logo/media/bs11.png';
import bs_asahi from '../../../images/logo/media/bs_asahi.jpg';
import fujitv from '../../../images/logo/media/fujitv.png';
import the_bridge from '../../../images/logo/media/the_bridge.png';
import mainichi from '../../../images/logo/media/mainichi.png';
import logme_biz from '../../../images/logo/media/logme-biz.png';

const mediaList = [
  { imagePath: nhk, alt: 'NHK', size: 'large' },
  { imagePath: j_wave, alt: 'J-WAVE' },
  { imagePath: shibuya_no_radio, alt: '渋谷のラジオ' },
  { imagePath: sotokoto, alt: 'ソトコト' },
  { imagePath: chiba_tv, alt: '千葉テレビ' },
  { imagePath: tbs_radio, alt: 'TBSラジオ' },
  { imagePath: tv_asahi, alt: 'テレビ朝日', size: 'large' },
  { imagePath: toyokeizai, alt: '東洋経済オンライン' },
  { imagePath: nikkin, alt: '日本金融通信社' },
  { imagePath: nikkei, alt: '日本経済新聞社' },
  { imagePath: japan_agri_news, alt: '日本農業新聞' },
  { imagePath: nihon_tv, alt: '日本テレビ', size: 'largest' },
  { imagePath: bs11, alt: 'BS11', size: 'largest' },
  { imagePath: bs_asahi, alt: 'BS朝日' },
  { imagePath: fujitv, alt: 'フジテレビジョン' },
  { imagePath: the_bridge, alt: 'THE BRIDGE' },
  { imagePath: mainichi, alt: '毎日新聞社' },
  { imagePath: logme_biz, alt: 'ログミーBiz' },
];

export default mediaList;
